var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"qrImg"},[_c('img',{staticStyle:{"width":"63vw","height":"63vw"},attrs:{"src":require('./../../assets/QR.jpg')}}),_vm._v(" "),_c('p',[_vm._v("扫一扫上面的二维码，联系顾问进行咨询")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b1c3bcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Member.vue
// module id = null
// module chunks = 